import styled from 'styled-components';

import { MiniBadge as MiniMadgeComponent } from '@xing-com/badge';
import { SingleSelect } from '@xing-com/menu';
import {
  cornerRadiusL,
  scale080,
  spaceL,
  spaceM,
  spaceS,
  xdlColorHover,
  xdlColorText,
} from '@xing-com/tokens';

// *** Components ***
const MoreListItem = styled(SingleSelect)`
  background-color: transparent;
  border-radius: ${cornerRadiusL};
  border-width: 0;
  color: ${xdlColorText};
  display: flex;
  font-size: ${scale080};
  font-weight: inherit;
  height: auto;
  justify-content: flex-start;
  outline: 0;
  padding-bottom: ${spaceM};
  padding-left: ${spaceL};
  padding-right: ${spaceL};
  padding-top: ${spaceM};
  width: 100%;

  &:focus,
  &:hover {
    background: ${xdlColorHover};
    color: ${xdlColorText};
    cursor: pointer;
    text-decoration: none;
  }
`;

const MoreItemInner = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const MiniBadge = styled(MiniMadgeComponent)`
  margin-right: ${spaceS};
`;

const MoreItemIcon = styled.div`
  line-height: 0;
  margin-right: ${spaceS};
`;

export const Styled = {
  MiniBadge,
  MoreItemIcon,
  MoreItemInner,
  MoreListItem,
};
